import Title from '../../Atoms/Title';
import Text from '../../Atoms/Text';
import Img from '../../Atoms/Image';
import Button from '../../Atoms/Button';
import Icon from '../../Atoms/Icon';
import Tag from '../../Atoms/Tag';
import InViewAnimate from '../../Atoms/InViewAnimate';
import List from '../../Molecules/List';
import FormSearch from '../../Molecules/FormSearch';
import {
  CardVisualList,
  Props as CardVisualProps
} from '../../Molecules/CardVisual';
import Steps from '../../Molecules/Steps';
import Mosaic from '../../Molecules/Mosaic';
import CardReviewSlider from '../../Organisms/CardReviewSlider';
import BannerCV from '../../Organisms/BannerCV';
import BlockEmployer from '../../Organisms/BlockEmployer';

import bgCard1 from '../../../assets/img/card-field-service-engineers.webp';
import bgCard2 from '../../../assets/img/card-mechanical-engineers.png';
import bgCard3 from '../../../assets/img/card-software-electrical-engineers.png';
import bgCard4 from '../../../assets/img/card-monteurs-technische-dienst.png';
import bgCard5 from '../../../assets/img/card-machinebouwers.png';
import bgCard6 from '../../../assets/img/card-installatietechniek.png';
import bgCard7 from '../../../assets/img/card-sales-engineers.png';
import bgCard8 from '../../../assets/img/card-projectleiders.png';
import bgCard9 from '../../../assets/img/card-werktuigbouwkunde.png';
import bgCard10 from '../../../assets/img/card-werktuigbouwkunde_.png';
import bgCard11 from '../../../assets/img/card-elektrotechniek.png';
import bgCard12 from '../../../assets/img/card-industriele-automatisering.png';
import ImgHeroMan from '../../../assets/img/homepage-hero-man.webp';
import ImgHeroDecor from '../../../assets/img/homepage-hero-decoration.svg';
import mosaic1 from '../../../assets/img/block-img-1.webp';
import mosaic2 from '../../../assets/img/block-img-2.webp';
import mosaic3 from '../../../assets/img/block-img-3.webp';
import mosaic4 from '../../../assets/img/block-img-4.webp';
import mosaic5 from '../../../assets/img/block-img-5.webp';

import svg from '../../../constants/svg';
import reviews from '../../../data/cardReviewSliderData';

const cards = [
  {
    title: '(Field) Service Engineers',
    href: '#!',
    bgImage: bgCard1,
    icon: 'windmill',
    badge: '567 vacatures'
  },
  {
    title: 'Mechanical Engineers',
    href: '#!',
    bgImage: bgCard2,
    icon: 'plug',
    badge: '908 vacatures'
  },
  {
    title: 'Software & Electrical Engineers',
    href: '#!',
    bgImage: bgCard3,
    icon: 'code',
    badge: '1.931 vacatures'
  },
  {
    title: 'Monteurs Technische Dienst',
    href: '#!',
    bgImage: bgCard4,
    icon: 'conveyor',
    badge: '799 vacatures'
  },
  {
    title: 'Machinebouwers',
    href: '#!',
    bgImage: bgCard5,
    icon: 'gear',
    badge: '557 vacatures'
  },
  {
    title: 'Installatietechniek',
    href: '#!',
    bgImage: bgCard6,
    icon: 'helmet',
    badge: '5 vacatures'
  },
  {
    title: 'Technisch-Commercieel',
    href: '#!',
    bgImage: bgCard7,
    icon: 'chart',
    badge: '248 vacatures'
  },
  {
    title: 'Operators',
    href: '#!',
    bgImage: bgCard8,
    icon: 'clipboard',
    badge: '1605 vacatures'
  }
];
const cardsYellow = [
  {
    title: 'Mechatronica',
    href: '#!',
    bgImage: bgCard9,
    icon: 'plug',
    badge: '3138 vacatures'
  },
  {
    title: 'Werktuigbouwkunde',
    href: '#!',
    bgImage: bgCard10,
    icon: 'gears',
    badge: '3007 vacatures'
  },
  {
    title: 'Elektrotechniek',
    href: '#!',
    bgImage: bgCard11,
    icon: 'lightning',
    badge: '2053 vacatures'
  },
  {
    title: 'Industriële Automatisering',
    href: '#!',
    bgImage: bgCard12,
    icon: 'robot',
    badge: '802 vacatures'
  }
];

const mosaicImages = [
  {
    src: mosaic1,
    alt: 'Mosaic 1'
  },
  {
    src: mosaic2,
    alt: 'Mosaic 2'
  },
  {
    src: mosaic3,
    alt: 'Mosaic 3'
  },
  {
    src: mosaic4,
    alt: 'Mosaic 4'
  },
  {
    src: mosaic5,
    alt: 'Mosaic 5'
  }
];

function Home() {
  return (
    <>
      <div className="relative min-h-[550px] bg-sl-blue pt-28 md:min-h-[600px] md:pt-40 md:pb-28 lg:min-h-[700px]">
        <div className="relative z-20 mx-auto w-full max-w-7xl px-7">
          <div className="flex flex-col gap-3 lg:w-full lg:max-w-[600px]">
            <Title
              as="h1"
              weight={900}
              size={1}
              color="white"
              className="mb-7 w-3/5 md:w-full"
            >
              <span>
                Level up <br className="md:hidden" />{' '}
                <mark>your job</mark>
              </span>
            </Title>
            <Text
              className="w-3/5 md:w-full"
              font="camphor"
              color="white"
            >
              Technisch professional? Jij weet wat je kunt.
              Wij weten waar dat kan.
            </Text>
            <List
              className="mb-24 lg:mb-10"
              icon="checkmark"
              listItems={[
                'De beste banen voor Monteurs en Engineers',
                'Netwerk van meer dan 2500 bedrijven',
                '1566 tevreden kandidaten gingen je voor!'
              ]}
            />
            <FormSearch
              className="mb-5 w-full max-w-sm md:max-w-xl"
              inputPlaceholder="Zoek jouw uitdaging uit 5.406 vacatures..."
              button={{
                text: 'Zoeken',
                color: 'primary',
                iconName: 'search',
                shadow: true
              }}
              mobileButton={{
                color: 'primary',
                iconName: 'search',
                shadow: true
              }}
            />
            <div className="mb-[-25px] flex w-full max-w-sm flex-wrap gap-7 md:max-w-xl">
              <div className="flex w-full md:w-auto md:max-w-[280px]">
                <Button
                  text="Bekijk alle 5.406 vacatures"
                  color="accent"
                  iconName="arrow-right"
                  shadow
                  fluid
                />
              </div>
              <div className="hidden md:flex">
                <Button
                  text="Open sollicitatie"
                  color="transparent-white"
                  smallText="Binnen 1 uur reactie"
                  shadow
                />
              </div>
            </div>
          </div>
        </div>

        <div className="pointer-events-none absolute top-0 bottom-0 right-0 left-0 z-10 overflow-hidden lg:bottom-[-150px] lg:overflow-auto">
          <Img
            src={ImgHeroDecor}
            className="ml-auto mr-[-200px] h-full max-w-[600px] object-cover object-right md:mr-0 md:ml-auto md:max-w-3xl md:object-bottom lg:mr-auto lg:h-full lg:max-w-full lg:object-center"
          />
          <div className="z-15 absolute left-0 right-0 bottom-0 mx-auto flex max-w-7xl lg:bottom-[150px] lg:px-8 xl:px-20">
            <Img
              src={ImgHeroMan}
              className="ml-auto mr-[-40px] h-[430px] object-contain object-center md:mr-0 lg:h-[600px]"
            />
          </div>
        </div>
      </div>
      <div className="bg-sl-gray-light pb-10 pt-10 lg:pt-20 lg:pb-32">
        <div className="relative z-20 mx-auto w-full max-w-7xl px-7">
          <Title
            as="h2"
            weight={900}
            size={3}
            color="blue"
            className="mb-7 text-center lg:mb-20 lg:text-left"
          >
            <span>
              <Icon icon="arrow-down" className="mr-3" />
              óf{' '}
              <b>
                bekijk direct de vacatures voor jouw
                specialisme
              </b>
            </span>
          </Title>

          <CardVisualList
            cards={cards as CardVisualProps[]}
            color="indigo"
          />
        </div>
      </div>

      <div className="relative bg-sl-gray-light pb-10 pt-10 lg:pt-20 lg:pb-44">
        <div className="relative z-20 mx-auto w-full max-w-7xl px-7">
          <Title
            as="h2"
            weight={900}
            size={2}
            color="blue"
            className="mb-7 text-center lg:mb-20 lg:text-left"
          >
            <span>
              Synsel. Makes. <br className="lg:hidden" />
              You. Move.
            </span>
          </Title>

          <CardVisualList
            cards={cardsYellow as CardVisualProps[]}
            color="yellow"
          />

          <div className="mt-12">
            <Button
              text="Bekijk alle 5.407 vacatures"
              iconName="arrow-right"
              shadow
              color="secondary"
            />
          </div>
          <div className="pointer-events-none absolute top-full hidden translate-y-3/4 -translate-x-1/2 select-none lg:block">
            {svg.qroCircleDarkOpen}
          </div>
          <InViewAnimate
            once
            hiddenClass="opacity-0 translate-x-14"
            visibleClass="opacity-100 translate-x-0"
            className="top-full z-20 -mt-20 hidden w-full duration-1000 ease-[cubic-bezier(0.17,0.55,0.55,1)] lg:absolute lg:left-1/3 lg:block lg:w-2/3 xl:left-1/2 xl:-mt-16 xl:w-[730px] 2xl:w-[780px]"
          >
            <BannerCV />
          </InViewAnimate>
        </div>
      </div>
      <div className="relative bg-white py-16 md:py-32 lg:py-40">
        <div className="relative z-20 mx-auto w-full max-w-7xl px-7">
          <Title as="h2" className="text-center">
            <span>
              Level up in
              <br className="lg:hidden" /> 5 stappen
            </span>
          </Title>
          <Steps />
          <div className="flex flex-wrap items-center justify-center gap-3 sm:gap-5">
            <Button
              text="Deel jouw cv"
              color="secondary"
              iconName="file-user"
              className="flex w-full items-center justify-center text-center sm:w-auto"
            />
            <Button
              text="Bekijk alle vacatures"
              color="accent"
              className="flex w-full items-center justify-center text-center sm:w-auto"
            />
          </div>
        </div>
      </div>
      <div className="relative flex flex-col bg-sl-indigo pt-16 pb-10 lg:py-24">
        <div className="relative z-20 mx-auto w-full max-w-7xl px-7">
          <Title
            as="h2"
            className="text-center"
            color="white"
          >
            <span>
              1.533 tevreden kandidaten <br /> gingen je
              voor!
            </span>
          </Title>
        </div>
        <div className="pointer-events-none absolute inset-0 z-10 mx-auto w-full max-w-[1600px] select-none">
          <div className="absolute bottom-full top-3 left-0 hidden translate-y-full lg:block">
            {svg.qrbCircleDarkOpen}
          </div>

          <div className="absolute bottom-full right-0 hidden translate-y-1/2 lg:block">
            {svg.lqkbCircleDark}
          </div>
        </div>
        <div className="overflow-hidden lg:mt-12">
          <CardReviewSlider reviewList={reviews} />
        </div>
      </div>

      <BlockEmployer />

      <div className="relative flex items-center justify-center bg-white py-10 pb-20 md:py-0">
        <div
          className="absolute left-7 right-7 z-20 m-auto max-w-5xl rounded-xl bg-sl-blue p-7 text-center shadow-2xl md:py-20 lg:px-28"
          style={{
            backgroundImage:
              'linear-gradient(225deg,#0E1C6B 0%,#23275B 100%)'
          }}
        >
          <Title as="h2" color="white">
            Oneindig veel kansen, aan jou de keuze
          </Title>
          <div className="mx-auto mt-7 max-w-xl lg:mt-12">
            <FormSearch
              inputPlaceholder="Zoek op functie of plaats..."
              button={{
                iconName: 'search',
                color: 'white',
                className:
                  'hover:!bg-white hover:!text-sl-indigo hover:!border-transparent'
              }}
            />
          </div>
          <div className="mx-auto mt-7 flex max-w-[240px] flex-wrap items-center gap-y-4 gap-x-16 text-xs text-white md:max-w-none md:justify-center md:text-lg lg:mt-12">
            <Tag
              iconClass="text-3xl w-[1em] mr-3"
              icon="shield"
              text="Alleen vaste tech banen"
              className="inline-block text-left"
            />
            <Tag
              iconClass="text-3xl w-[1em] mr-3"
              icon="award-duotone"
              text="Jouw vak, ons specialisme"
              className="inline-block text-left"
            />
          </div>
        </div>
        <Mosaic
          className="max-w-[1600px] -translate-y-14"
          images={mosaicImages}
        />
      </div>
    </>
  );
}

export default Home;
